import { IArticleResponse } from "@faire/help-center-utils/types/zendesk";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { IGetArticleResponse } from "@faire/web-api--source/com/faire/vendor/zendesk/IGetArticleResponse";

interface ArticleContext {
  articleData: IArticleResponse | IGetArticleResponse | undefined;
  isLoading: boolean;
}

const INITIAL_STATE: ArticleContext = {
  articleData: undefined,
  isLoading: false,
};

const { useStore: useArticleContextStore, Provider: ArticleContextProvider } =
  createContextStore<ArticleContext>(INITIAL_STATE);

export { ArticleContextProvider, useArticleContextStore };
